import { render, staticRenderFns } from "./ModalLoading.vue?vue&type=template&id=771c4090&"
import script from "./ModalLoading.vue?vue&type=script&lang=js&"
export * from "./ModalLoading.vue?vue&type=script&lang=js&"
import style0 from "./ModalLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports